module.exports = __webpack_public_path__ + "static/media/foto2.66b3c213.jpeg";